/**
 * Tag (pill) — primitive Editorial Operations (HiFi.3).
 *
 * Petite étiquette uppercase 9 px posée à droite d'une ListRow ou
 * en kicker secondaire. Cinq variantes :
 *
 *   - `default`  : neutre (--ink-soft sur fond panel, border --rule)
 *   - `event`    : couleur du mode courant (--accent-deep)
 *   - `task`     : sable foncé (--sand-deep) avec border --warn
 *   - `warn`     : variante remplie pour les alertes douces
 *   - `sage`     : fond sage clair (mode classique fixe)
 *   - `slate`    : fond slate clair (mode coparenting fixe)
 *
 * Les variantes `sage`/`slate` permettent d'afficher la couleur d'un
 * parent (A/B) sans dépendre du mode courant — utile dans le
 * calendrier de garde où chaque cellule porte sa propre teinte.
 */
import { html, type TemplateResult } from 'lit-html';
import styles from './editorial.module.css';

export type TagKind = 'default' | 'event' | 'task' | 'warn' | 'sage' | 'slate';

export interface TagProps {
  label: string;
  kind?: TagKind;
  /** testid optionnel. */
  testid?: string;
}

const KIND_CLASS: Record<TagKind, string> = {
  default: '',
  event: styles.tagEvent ?? '',
  task: styles.tagTask ?? '',
  warn: styles.tagWarn ?? '',
  sage: styles.tagSage ?? '',
  slate: styles.tagSlate ?? '',
};

export function tag({ label, kind = 'default', testid }: TagProps): TemplateResult {
  const cls = `${styles.tag} ${KIND_CLASS[kind]}`.trim();
  return html`<span class=${cls} data-testid=${testid ?? 'tag'}>${label}</span>`;
}
